export const INITIAL_USE_INTERNAL_TUNNEL_BOOKING_FILTERS = {
    filters: null,
    completion: null,
    calculatedPrice: null
};
